// extracted by mini-css-extract-plugin
export default {"divPadre":"loading_divPadre__uhexh","divHijo":"loading_divHijo__ehqED","logo":"loading_logo__OG3Qg"};